module.exports = __webpack_public_path__ + "img/banner.6af175f5.png";